export const BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://staging.arriendoasegurado.com/v2'
    : 'http://localhost:8000/v2'
export const AUTH0_ROLES = 'https://api.houm.com/roles'
export const AUTH0_CLIENTID = 'vqVrhhytKNgPxAz3cpAxsJwbwrbcHZYR'
export const AUTH0_DOMAIN = 'houm-staging.us.auth0.com'
export const AUTH0_AUDIENCE = 'https://houm-staging-api'
